// extracted by mini-css-extract-plugin
export var actionIcon = "_tm-0";